import React from "react";
import "./index.scss";
import CountUp from "react-countup";
import { useHistory } from "react-router-dom";
const DeliveryBox = (boxData) => {
  const history = useHistory();

  return (
    <>
      <div
        className="invoice-result-box"
        style={{
          backgroundColor: boxData.data.color,
          backgroundImage: "url(" + boxData.data.bgImg + ")",
        }}
        onClick={() => {
          history.push(boxData?.data?.url);
        }}
      >
        <h4 style={{ color: boxData.data.textColor }}>{boxData.data.text}</h4>
        <h2 style={{ color: boxData.data.textColor }}>
          <CountUp
            end={boxData.data.value}
            duration={0.75}
            decimals={2}
            formattingFn={(value) => {
              const formatted = new Intl.NumberFormat("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);

              return `${formatted} ₺`;
            }}
          />
        </h2>
      </div>
    </>
  );
};

export default DeliveryBox;
